import styled from 'styled-components';

import { pxToRem, WithThemeProps } from '../../styles';

type RootProps = {
	fullWidth: boolean;
}

const Root = styled.div`
	position: relative;
	display: inline-block;

	${(p: RootProps) => p.fullWidth && `
		width: 100%;
	`}
`;

const TextFieldLayout = styled.div`
	position: relative;
	width: 100%;

	&::after {
		content: '';
		position: absolute;
		left: 0;
		top: 15px;
		width: calc(100% - 50px);
		height: 30px;
		background-color: transparent;
		cursor: pointer;
	}

	& input {
		padding-right: 50px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	& svg {
		cursor: pointer;
	}
`;

const SearchFieldLayout = styled.div`
	width: 100%;
	padding: 8px 16px 0 16px;
`;

const ItemsLayout = styled.div`
	position: relative;
	width: 100%;
	max-height: 300px;
	overflow-y: auto;
`;

const Placeholder = styled.div`
	padding: 8px 16px;
	text-align: center;
	font-size: ${pxToRem(12)};

	${(p: WithThemeProps) => p.theme && `
		color: ${p.theme.palette.blackSecondary};
	`}
`;

const IconLayout = styled.div`
	position: absolute;
	left: 15px;
	top: 50%;
	transform: translate(0, -50%);
	font-size: 0;
`;

export {
	Root,
	TextFieldLayout,
	SearchFieldLayout,
	ItemsLayout,
	Placeholder,
	IconLayout,
};
